export type WenxinSizes = "1024*1024" | "1024*1536" | "1536*1024";
export const allWenxinStyles = [
  "古风",
  "二次元",
  "写实风格",
  "浮世绘",
  "low poly",
  "未来主义",
  "像素风格",
  "概念艺术",
  "赛博朋克",
  "洛丽塔风格",
  "巴洛克风格",
  "超现实主义",
  "水彩画",
  "蒸汽波艺术",
  "油画",
  "卡通画",
] as const;
export type WenxinStyles = typeof allWenxinStyles[number];

export type WenxinOptions = {
  text: string;
  size: WenxinSizes;
  style: WenxinStyles;
  url?: string;
};
